import React, { useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon, EyeIcon } from 'lucide-react';
type Preview = {
  title: string;
  description: string;
  imageUrl: string;
};
const previews: Preview[] = [{
  title: '52-Week Visual Calendar',
  description: 'A clear weekly roadmap so you always know what to teach next.',
  imageUrl: 'https://cdn.magicpatterns.com/uploads/vjuPDVVbBtYDRwS9tyqo7D/Captura-de-pantalla-2026-07-24-a-la_s_-12.05.56_p._m..webp'
}, {
  title: 'Hero Move Cards',
  description: 'Professional cues, common errors, and practical fixes for every move.',
  imageUrl: 'https://cdn.magicpatterns.com/uploads/f2EU37N8C32HutNCSk8Amm/Captura-de-pantalla-2026-07-24-a-la_s_-12.30.21_p._m..webp'
}, {
  title: 'Mixed-Level Planning Sheet',
  description: 'Create inclusive classes with clear options for every student in the room.',
  imageUrl: 'https://cdn.magicpatterns.com/uploads/s873j474T1EAYeiLLgc26o/Captura-de-pantalla-2026-07-24-a-la_s_-12.30.47_p._m..webp'
}, {
  title: 'Core Anatomy Guide',
  description: 'Teach with clarity using visual anatomy and precise coaching language.',
  imageUrl: 'https://cdn.magicpatterns.com/uploads/owrQghC8g2kcB94yLMWsXg/Captura-de-pantalla-2026-07-24-a-la_s_-12.06.32_p._m..webp'
}, {
  title: 'Flow Class Review',
  description: 'Reflect, refine, and make every class feel more intentional over time.',
  imageUrl: 'https://cdn.magicpatterns.com/uploads/f9iq4UaNAksZfNWTCnH6oN/Captura-de-pantalla-2026-07-24-a-la_s_-12.07.08_p._m._(1).webp'
}];
export function InsideMaterialCarousel() {
  const [activeIndex, setActiveIndex] = useState(0);
  const activePreview = previews[activeIndex];
  const goToPrevious = () => {
    setActiveIndex(currentIndex => currentIndex === 0 ? previews.length - 1 : currentIndex - 1);
  };
  const goToNext = () => {
    setActiveIndex(currentIndex => currentIndex === previews.length - 1 ? 0 : currentIndex + 1);
  };
  return <section className="bg-[#fff7fb] px-5 py-20" data-id="element-133" data-mp="1r0jpooocqbc7">
      <div className="mx-auto max-w-6xl" data-id="element-134" data-mp="1qzqglh1x79qw">
        <div className="mx-auto max-w-3xl text-center" data-id="element-135" data-mp="1vyl5n0qhdujg">
          <p className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[.2em] text-emerald-700" data-id="element-136" data-mp="1vx0bhc82wdm4">
            <EyeIcon className="h-4 w-4" data-id="element-137" data-mp="25owmtoz6e08a" /> See what&apos;s inside
          </p>
          <h2 className="mt-3 font-display text-4xl font-bold uppercase leading-none text-[#241322] sm:text-5xl" data-id="element-138" data-mp="25qzai2cuvh9u">
            Made to use in the <span className="text-emerald-700" data-id="element-139" data-mp="1czz2lgbeltcw">real world</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-sm font-medium leading-relaxed text-slate-600 sm:text-base" data-id="element-140" data-mp="1d223wwi0b8wx">
            Open a volume and find the plan, cue, or teaching tool you need — without starting from a blank page.
          </p>
        </div>

        <div className="mt-11 grid overflow-hidden border border-[#ead9e5] bg-white lg:grid-cols-[minmax(0,1fr)_310px]" data-id="element-141" data-mp="2tdpa6x1qezra">
          <div className="relative flex min-h-[510px] items-center justify-center bg-[#f7edf4] p-5 sm:p-8" data-id="element-142" data-mp="2ybquflaw954c">
            <img key={activePreview.imageUrl} src={activePreview.imageUrl} alt={`Preview of the ${activePreview.title} included in Pilates Ready`} width={728} height={1280} className="max-h-[620px] w-auto max-w-full border border-[#ead9e5] object-contain shadow-2xl" data-id="element-143" data-mp="msb3r488aop5" />
            <button type="button" onClick={goToPrevious} aria-label="Show previous material preview" className="absolute left-3 top-1/2 grid h-12 w-12 -translate-y-1/2 place-items-center rounded-full border border-white/70 bg-[#241622]/90 text-white shadow-lg transition-colors hover:bg-[#a72a67] sm:left-6 sm:h-14 sm:w-14" data-id="element-144" data-mp="330pzvs1mdto">
              <ChevronLeftIcon className="h-6 w-6" data-id="element-145" data-mp="1oeizmzcqcmpz" />
            </button>
            <button type="button" onClick={goToNext} aria-label="Show next material preview" className="absolute right-3 top-1/2 grid h-12 w-12 -translate-y-1/2 place-items-center rounded-full border border-white/70 bg-[#241622]/90 text-white shadow-lg transition-colors hover:bg-[#a72a67] sm:right-6 sm:h-14 sm:w-14" data-id="element-146" data-mp="1jfzbcsanyyug">
              <ChevronRightIcon className="h-6 w-6" data-id="element-147" data-mp="c3q5sab17nk6" />
            </button>
          </div>

          <aside className="flex flex-col bg-[#241622] p-7 text-left sm:p-9" data-id="element-148" data-mp="3tkhtfgb3lmo1">
            <p className="text-xs font-bold uppercase tracking-[.18em] text-emerald-300" data-id="element-149" data-mp="3tidfe5jhj7a1">
              Preview {String(activeIndex + 1).padStart(2, '0')} / {String(previews.length).padStart(2, '0')}
            </p>
            <h3 className="mt-4 font-display text-4xl font-bold uppercase leading-none text-white" data-id="element-150" data-mp="3khyuv8echw7l">
              {activePreview.title}
            </h3>
            <p className="mt-5 text-sm font-medium leading-relaxed text-slate-300" data-id="element-151" data-mp="3amx3s70iek2d">
              {activePreview.description}
            </p>
            <p className="mt-auto border-t border-emerald-300/20 pt-6 text-xs font-bold uppercase tracking-[.14em] text-emerald-200" data-id="element-152" data-mp="3fmjf2aws1q8j">
              A closer look at your ready-to-use tools
            </p>
            <div className="mt-5 flex gap-2" aria-label="Choose a material preview" data-id="element-153" data-mp="35x32emymc59q">
              {previews.map((preview, index) => <button key={preview.title} type="button" onClick={() => setActiveIndex(index)} aria-label={`Show ${preview.title}`} aria-pressed={index === activeIndex} className={`h-2.5 w-2.5 rounded-full transition-colors ${index === activeIndex ? 'bg-emerald-300' : 'bg-white/30 hover:bg-white/60'}`} data-id="element-154" data-mp="30wykcsi2b2he" data-mpi={index} />)}
            </div>
          </aside>
        </div>
      </div>
    </section>;
}